"use client";

import { Armchair, ArrowRight, Hammer, Link2 } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Card, CardContent } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function MasteringGoogleListings() {
  const {
    ref: headerRef,
    isVisible: headerVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.2
  });
  const {
    ref: gridRef,
    isVisible: gridVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.1
  });
  const pillars = [{
    number: "01",
    title: "Website Design",
    description: "We build high-performance, responsive websites tailored to convert your visitors into loyal customers.",
    icon: Armchair,
    href: "/WebsiteDesignPage",
    offset: "lg:mt-0"
  }, {
    number: "02",
    title: "SEO Strategy",
    description: "Drive organic growth with data-driven search engine optimization that puts your brand in front of the right audience.",
    icon: Hammer,
    href: "/SeoPage",
    offset: "lg:mt-16"
  }, {
    number: "03",
    title: "Local SEO",
    description: "Dominate your local market by resolving Google listing issues and optimizing your presence for nearby searches.",
    icon: Link2,
    href: "/LocalSeoPage",
    offset: "lg:-mt-8"
  }];
  return;
}